import sessionCache from '@/utils/session_storage'

const setLoginFrom = (from = '') => {
    sessionCache.set('LOGIN_FROM', from)
}

const getLoginFrom = () => {
    return sessionCache.get('LOGIN_FROM') || ''
}

const pushLoginFrom = () => {
    const from = sessionCache.get('LOGIN_FROM') || ''
    sessionCache.remove('LOGIN_FROM')
    return from
}

export { setLoginFrom, getLoginFrom, pushLoginFrom }
